import { atom } from "recoil";

const AirlineSelectedIataAtom = atom<string>({
    default: '',
    key: 'airlineSelectedIataAtomKey'
})

export default AirlineSelectedIataAtom;